import { Invoice } from '@mews-commander/data-access';
import { LocalizedDateFromUtc } from '@mews-commander/ui';
import { UnicodeEntity } from '@mews/enums';
import { DateTimeUtcService, LocalizedText, useAppClockService } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { TagProps } from '@optimus-web/core';
import { localizeCurrencyValue } from '@mews-commander/utils';

export const useGetTagPropsForInvoice = () => {
    const appClockService = useAppClockService();

    return (invoice: Invoice): TagProps => {
        const now = appClockService.getAppNowUtc();
        const dueDate = invoice.dueUtc ? DateTimeUtcService.parse(invoice.dueUtc) : now;
        const isOverdue = DateTimeUtcService.isGreater(now, dueDate);

        if (isOverdue) {
            return {
                variant: 'warning',
                children: <LocalizedText textKey={TextKey.Overdue} />,
            };
        }

        return {
            variant: 'info',
            children: <LocalizedText textKey={TextKey.Unpaid} />,
        };
    };
};

export const useCreateInvoiceLabel = () => (invoice: Invoice) => (
    <>
        <LocalizedText textKey={TextKey.Invoice} />
        {UnicodeEntity.NoBreakSpace}
        {invoice.number}
    </>
);

export const useCreateInvoiceSecondaryText = () => (invoice: Invoice) => (
    <>
        <LocalizedText textKey={TextKey.DueDate} />
        {UnicodeEntity.NoBreakSpace}
        {invoice.dueUtc ? <LocalizedDateFromUtc utcString={invoice.dueUtc} /> : null}
        {UnicodeEntity.NoBreakSpace}
        {UnicodeEntity.Pipe}
        {UnicodeEntity.NoBreakSpace}
        {localizeCurrencyValue({ value: invoice.balance.value, currency: invoice.balance.currency })}
    </>
);
